import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from '../ui/alert-dialog';

export const DeleteNotificationsDialog = ({ open, onOpenChange, busy, onConfirm }) => {
  const { t } = useTranslation('common');
  return <AlertDialog open={open} onOpenChange={(value) => { if (!busy) onOpenChange(value); }}>
    <AlertDialogContent className="max-w-[min(420px,calc(100vw-24px))]" data-testid="notifications-delete-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle data-testid="notifications-delete-confirm-title">{t('notification_center.confirm_title')}</AlertDialogTitle>
        <AlertDialogDescription data-testid="notifications-delete-confirm-description">{t('notification_center.confirm_description')}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={!!busy} data-testid="notifications-delete-confirm-cancel">{t('notification_center.cancel')}</AlertDialogCancel>
        <AlertDialogAction disabled={!!busy} className="bg-red-700 text-white hover:bg-red-600"
          onClick={async (event) => { event.preventDefault(); if (await onConfirm()) onOpenChange(false); }}
          data-testid="notifications-delete-confirm-submit">{t('notification_center.delete_all')}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
};